/**
 *
 */
function onPlayerStateChange(event) {
	if (event.data == YT.PlayerState.PAUSED || event.data == YT.PlayerState.ENDED) {
		$('#playYtVideo').fadeIn();
	}
}

$(function () {
	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	var player;
	window.onYouTubeIframeAPIReady = function() {
		let ytId = $('#youtubeVideo').attr('data-ytId');
		player = new YT.Player('youtubeVideo', {
			width: '100%',
			height: '100%',
			videoId: ytId,
			loop: 1,
			rel: 0,
			modestbranding: 1,
			frameborder:0,
			iv_load_policy: 3,
			showinfo:0,
			events: {
		      'onStateChange': onPlayerStateChange
		    }
		});
	}
	
	$('#playYtVideo').on('click', function() {
		let playerState = player.getPlayerState();
		switch(playerState) {
			case -1:
				player.playVideo();
				$('#playYtVideo').fadeOut();
				break;
			case 0:
				player.playVideo();
				$('#playYtVideo').fadeOut();
				break;
			case 2:
				player.playVideo();
				$('#playYtVideo').fadeOut();
				break;
			case 5:
				player.playVideo();
				$('#playYtVideo').fadeOut();
				break;
		}
	})
});
